//
//

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { debounce, date } from "quasar";
import { Diagram,
    DiagramComponent as ejsDiagram, DiagramTools, LineRouting, Rect, ConnectorBridging, ConnectorConstraints } from "@syncfusion/ej2-vue-diagrams";
import appStats from "@/components/Diagrams/sidebar/appStats.vue";
import PluginContainer from "@/components/Diagram/PluginContainer/PluginContainer.vue";
import PluginSidebar from "@/components/Diagram/PluginSidebar/PluginSidebar.vue";
import pluginDescription from "@/components/Diagrams/sidebar/plugin-description.vue";
import canvasElements from "@/components/Diagrams/sidebar/canvas-elements.vue";
import { eventBus, infoToastPublish, $http } from "@/assets/js/appFunc";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDefaultState from "@/components/Generics/AQDefaultState/AQDefaultState.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import { diagramConfig, convertOldDiagram, getNodeDefaults, setAnchoredOnDiagram, annotationConfig } from "./DiagramConfig";
import ReportsTasksAndInstances from "../ReportsTasksAndInstances/ReportsTasksAndInstances.vue";
import SavedFiltersModal from "../SearchFiltersReports/SavedFiltersModal.vue";
import SearchFiltersReports from "../SearchFiltersReports/SearchFiltersReports.vue";
import SearchPerspectiveSidebar from "./SearchPerspectiveSidebar.vue";

Diagram.Inject(LineRouting);
Diagram.Inject(ConnectorBridging);
let diagramInstance;

export default {
    name: "ReportsContent",
    components: {
        PluginContainer,
        PluginSidebar,
        pluginDescription,
        canvasElements,
        appStats,
        AQButton,
        ReportsTasksAndInstances,
        AQTooltip,
        SearchFiltersReports,
        SavedFiltersModal,
        AQDefaultState,
        SearchPerspectiveSidebar,
        AQList,
        AQEmptyState,
        AQSkeleton,
        ejsDiagram,
        AQSearch,
        AQEmptySearch
    },
    props: {
        pageType: {
            type: String,
            default: "reports"
        },
        customTitle: {
            type: String,
            default: ""
        },
        defaultStateTitle: {
            type: String,
            default: ""
        },
        defaultStateDescription: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            appLoaded: false,
            openSearch: false,
            selectedAchoredPlugin: {},
            expandDiagramContent: true,
            hideSearchCollapse: false,
            contentTasksStatus: "collapse",
            showSearchFilters: false,
            showSearchContent: false,
            collapseSearchFilters: true,
            tasksIsFullScreen: false,
            hideDiagram: false,
            setZoomBottomHeight: 0,
            readonly: false,
            nrFiltersApplied: 0,
            initialFilters: null,
            allTasksReady: false,
            isReady: false,
            isCompleted: false,
            noFilterResults: true,
            pageName: "Reports",
            filters: null,
            counter: 600,
            taskTypeCompleted: false,
            anchorPoz: null,
            showAppTracer: false,
            refreshDiagram: false,
            activeTab: "tasks",
            plvStatusMode: true,
            addFilterModal: false,
            searchTerm: "",
            payloadFiltered: {},
            noFilters: true,
            iconName: "",
            fromDate: "",
            toDate: "",
            creationDate: false,
            finalFilterObject: { taskFilterModel: {} },
            usersList: [],
            showStatistics: false,
            groupsList: [],
            isOpenAndCompleted: false,
            turnAroundValue: "ONE_WEEK",
            showSavedFiltersModal: false,
            filterDetails: null,
            exportModal: false,
            resetStatus: false,
            favoriteFilters: [],
            filtersList: [],
            activitiesData: [],
            activitiesDataPerspective: [],
            isSearchContainerOpened: false,
            processList: [],
            resetFilters: false,
            refreshDataWhenTabChanges: true,
            perspectiveData: {},
            currentPerspective: "",
            propFullScreen: false,
            propExpandCollapse: "",
            tableExtData: null,
            perspectiveNoProcessId: null,
            hasCustomInterface: false,
            perspectiveList: [],
            updatePerspective: 0,
            perspectiveTakeAction: false,
            keepDiagramHidden: false,
            allowRedirectDenied: true,
            selectedPerspective: null,
            diagramConfig,
            currentSelectedPerspectiveId: null,
            perspectiveNewList: [],
            loading: true,
            zoomLevel: 100,
            searchProcess: "",
            closeSearchField: false,
            diagramSettings: {
                showGrid: true,
                showBridges: true,
                showLabels: true
            },
            settingsEnabled: true,
            showSettings: false,
            showSettingsStatistics: false,
            filteredProcessesList: [],
            diagramLoaded: false
        };
    },
    computed: {
        diagramId() {
            return `diagram${Math.floor(Math.random() * 100000)}`;
        },
        ...mapGetters("diagrams", ["selectedPluginConfigData", "selectedPluginUuid", "selectedPluginData", "diagramConfigData", "diagramData"]),
        ...mapGetters("main", ["getCurrentApplicationId", "getCurrentProcessId"]),
        ...mapGetters("reports", [
            "getThresholds",
            "filterObject",
            "getFiltredTasks",
            "getInitialDiagramData",
            "getSelectedProcessReports",
            "getSelectedProcessStatistics"
        ]),
        ...mapGetters("admin", ["roleList", "userList", "getGroupsListApp", "getAllSelectedMembers"]),
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("perspectiveBuilder", ["getPerspectiveId", "getPerspectivesList"]),
        ...mapState("perspectiveBuilder", ["searchPerspectiveData"]),
        checkNoDataReports() {
            return this.activeTab === "tasks" ? "noProcessData" : "noStatistics";
        },
        checkEmptyStateInterface() {
            return this.perspectiveList.length ? "noPerspectiveProcess" : "noPerspective";
        },
        isSearchPerspective() {
            return this.pageType === "searchPerspectives";
        },
        checkDiagramVisibility() {
            return this.keepDiagramHidden || this.hideDiagram;
        },
        setSearchContainerClass() {
            return `${this.collapseSearchFilters ? "hide-search-container" : "active-search-container"} ${this.tasksIsFullScreen ? "remove-shadow" : ""}`;
        },
        getCurrentSelectedProcess() {
            return this.getSelectedProcessReports[this.pageType];
        },
        getNoInterfacesTitle() {
            return this.defaultStateTitle || this.$t(`reports.${this.processList.length ? "selectProcessTitle" : "noProcessesTitle"}`);
        },
        getNoInterfacesDesc() {
            return this.defaultStateDescription || this.$t(`reports.${this.processList.length ? "selectProcessDescription" : "noProcessesDescription"}`);
        },
        showFavFilters() {
            return this.getCurrentSelectedProcess.name && !!this.favoriteFilters.length && this.activeTab === "tasks";
        },
        showSelectProcessState() {
            return !this.$route.params.processAnalyticsId;
        },
        getSizeLayout() {
            let data;
            if (this.showStatistics) {
                data = this.expandDiagramContent ? "diagram-container-expanded-statistics" : "diagram-container-statistics";
            } else {
                data = this.expandDiagramContent ? "diagram-container-expanded" : "diagram-container-normal";
            }
            return data;
        },
        canSeeTI() {
            return (
                this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("TI")
            );
        },

        canSeeST() {
            return (
                this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("ST")
            );
        },
        showIconSearchFilters() {
            let checkValue = !this.showStatistics;
            if (!this.showStatistics) {
                if (!this.showSearchFilters) {
                    checkValue = !this.showSearchFilters;
                } else {
                    checkValue = this.collapseSearchFilters;
                }
            }
            return checkValue;
        },
        isOwner() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("owner");
        },

        data: {
            get() {
                return {};
            },
            set(data) {
                if (data && (data.content || data.connectors)) {
                    this.$store.commit("diagrams/diagramData", data);
                }
            }
        },
        config() {
            return { readonly: this.readonly };
        },
        currentPluginSelectedData() {
            return this.selectedPluginConfigData;
        },
        computedThresholds() {
            return this.getThresholds;
        },
        getTasksClasses() {
            let classes = `tasks-content-${this.contentTasksStatus}`;
            if (this.checkDefaultItems) {
                classes = "hide-diagram";
            } else if (this.showStatistics) {
                classes = "remove-shadow remove-tabel";
            } else if (this.tasksIsFullScreen) {
                classes = "remove-shadow";
            }
            return classes;
        },
        checkDefaultItems() {
            return this.isSearchPerspective ? !this.currentSelectedPerspectiveId : this.showSelectProcessState;
        },
        checkDiagramIsHidden() {
            return (this.checkDefaultItems || (!this.showStatistics && this.checkDiagramVisibility));
        }
    },
    watch: {
        $route: {
            handler(route, oldRoute) {
                if (this.pageType === "reports" && !this._inactive
                && (route.name !== oldRoute?.name
                || (!route.params.processAnalyticsId && oldRoute?.params?.processAnalyticsId))) {
                    if (!route.params.processAnalyticsId && oldRoute?.params?.processAnalyticsId) {
                        this.contentTasksStatus = "collapse";
                        this.collapseSearchFilters = true;
                    }
                    this.routeTo(route.name);
                    this.searchProcess = "";
                    this.closeSearchField = true;
                    setTimeout(() => {
                        this.closeSearchField = false;
                    }, 200);
                } else if (this.isSearchPerspective && !route.params.dataViewsId && oldRoute?.params?.dataViewsId) {
                    this.$store.commit("perspectiveBuilder/setSearchPerspectiveData", {});
                    this.returnToDefault();
                }
            },
            immediate: true
        },
        getCurrentApplicationId() {
            this.refreshDiagram = true;
        },
        getThresholds(v) {
            this.getAllTasksDiagrams(v);
        },
        selectedPluginUuid(newValue) {
            if (this.plvStatusMode && newValue) {
                this.getStageDetails();
            }
        },
        collapseSearchFilters: {
            handler(value) {
                this.isSearchContainerOpened = !value;
            }
        },
        searchProcess: {
            handler() {
                this.searchForProcess();
            }
        }
    },
    created() {
        this.isReady = true;
        this.$root.$on("clearAllMembers", () => {
            this.usersList = [];
            this.groupsList = [];
            this.isOpenAndCompleted = false;
        });
        this.$store.dispatch("diagrams/getDiagramPlugins");
        this.debounceFunction = debounce(function debounceFn() {
            if (!this.$route.query.filterId) {
                this.actionGetAllTasks({ data: this.filterObject, activeTab: this.activeTab, pageType: this.pageType }).then(rsp => {
                    this.allTasksReady = true;
                    this.$store.commit("reports/setAllTasks", rsp);
                    this.$store.commit("reports/setFiltredTasks", rsp);
                    this.$store.commit("reports/setInitialDiagramData", rsp);
                    this.isReady = false;
                    this.setViewModifications();
                });
            }
        }, this.counter);
        this.onDiagramEvent = debounce(this.diagramEvent, 100);
    },
    mounted() {
        const { query, params } = this.$route;
        if (params.dataViewsId && Object.keys(query).length) {
            eventBus.$emit("perspectiveLoaded");

            let process = {};
            const { processId: id, processName: name } = this.searchPerspectiveData.setup;
            this.perspectiveList = JSON.parse(JSON.stringify(this.getPerspectivesList));
            if (id && name) {
                process = { id, name, perspectiveId: params.dataViewsId };
            }
            this.currentSelectedPerspectiveId = params.dataViewsId;
            this.setPerspectiveConfig({ ...this.searchPerspectiveData, process });
            this.loading = false;
            this.perspectiveNoProcessId = null;
        }

        if (!this.isSearchPerspective && query.search) {
            this.searchProcess = query.search;
            this.openSearch = true;
            this.$nextTick(() => { this.openSearch = false; });
        }
        if (params.processAnalyticsId && Object.keys(query).length) {
            this.openSearchFilters();
        }
        if (diagramInstance) {
            diagramInstance.fitToPage();
        }
    },
    activated() {
        const { params: { dataViewsId }, query } = this.$route;
        if (!query.search) {
            this.searchProcess = "";
        }
        if (this.pageType === "reports") {
            this.getProcesses();
        } else if (this.isSearchPerspective) {
            if (!dataViewsId || !Object.keys(query).length) {
                this.actGetCasePerspectives().then(({ data }) => {
                    this.perspectiveNewList = data;
                    this.$store.commit("perspectiveBuilder/setPerspectivesList", data);
                    this.perspectiveList = data;
                    const selected = this.currentSelectedPerspectiveId || this.perspectiveNoProcessId;
                    const checkIfSelectedExist = () => data.find(({ id }) => id === selected);
                    if (selected && this.searchPerspectiveData.id !== selected) {
                        if (checkIfSelectedExist()) {
                            this.loadPerspective(selected);
                        } else {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.$t("exportReports.noPermission")
                            });
                            this.returnToDefault();
                        }
                    }
                });
            }
            this.$root.$on("bc__searchPerspectives__open", this.crumbOpen);
        }

        this.addEventListeners();

        this.$root.$emit("setReadonlyTag", this.$route.params.permissions && this.$route.params.permissions.readonly);

        const payload = {
            processDefinitionId: "",
            applicationId: this.currentApp.id,
            behaviour: this.pageType === "searchPerspectives" ? "Access Search Perspectives" : "Access Reports"
        };
        this.updateProcessInstance(payload);
        if (this.$route.name === "statistics") {
            this.activeTab = "statistics";
            this.showStatistics = true;
        } else {
            this.activeTab = "tasks";
            this.showStatistics = false;
        }
        this.plvStatusMode = true;
        if (this.appLoaded && !this.isSearchPerspective) {
            eventBus.$emit("refreshReportsTasks");
        } else {
            this.appLoaded = true;
        }
        this.allowRedirectDenied = true;
        this.$root.$emit("activeEnterEv", !this.showStatistics);
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
    },
    deactivated() {
        if (this.pageType === "reports") {
            this.$store.commit("reports/setSelectedProcessReports", { process: {}, pageType: this.pageType });
            this.$store.commit("reports/setSelectedProcessStatistics", {});
        }
        this.returnToDefault(this.activeTab, true);
    },
    methods: {
        ...mapActions("reports", [
            "actionGetAllTasks",
            "getActivityReportsTasks",
            "getFilter",
            "getAllFavoritesFilters",
            "getCurrentActivityTasks",
            "getAllReportsActivities"
        ]),
        ...mapActions("apps", ["updateProcessInstance", "getProcessesForReports"]),
        ...mapMutations("reports", ["setFilterObject", "setSearchInSearchFilter", "setInitialDiagramData"]),
        ...mapMutations("diagrams", ["setCopyOfInitialContentDiagram"]),
        ...mapActions("perspectiveBuilder", ["actGetCasePerspectives", "actLoadCasePerspectiveData"]),
        oncreate() {
            diagramInstance = this.$refs.diagramObject.ej2Instances;
        },
        getConnectorDefaults(conn) {
            conn.type = "Orthogonal";
            conn.style = {
                strokeWidth: 2,
                strokeColor: "#6C778B"
            };

            const [{ content } = {}] = conn.annotations;
            if (content) {
                conn.annotations = [
                    {
                        ...annotationConfig,
                        content
                    }
                ];
            } else {
                conn.annotations = [];
            }

            conn.targetDecorator = {
                shape: "Custom",
                // eslint-disable-next-line max-len
                pathData: "M0 6.66897C0.00215222 6.24581 0 5.75396 0 5.32897C1.8812 3.91732 7.9951 -0.583682 7.22917 0.0679785L1.53035 5.7668H11.77C11.8999 5.7668 12 5.87208 12 6.00195C12 6.13182 11.8999 6.2371 11.77 6.2371H1.53219L7.22917 11.9341C7.9951 12.5848 1.8812 8.07942 0 6.66897Z",
                style: {
                    strokeWidth: 1,
                    fill: "#6C778B",
                    strokeColor: "#6C778B"
                }
            };
            if (this.diagramSettings.showBridges) {
                conn.constraints = ConnectorConstraints.Bridging; // 256
            } else {
                conn.constraints = ConnectorConstraints.ReadOnly; // 16384
            }
        },
        getNodeDefaults,
        selectActivity(ev) {
            if (!this.readonly) {
                if (ev.target.id === `${this.diagramId}_diagramLayer_svg`) {
                    diagramInstance.clearSelection();
                }
                if (ev.target.dataset.pluginid === "ANCHORED_HEXAGON") {
                    const { nodeid: pluginUuid, position: anchorPosition, pluginid: pluginId } = ev.target.dataset;
                    if (anchorPosition === "CENTER_CENTER") {
                    // request fails for total filter...
                        return;
                    }

                    // manual selection since we changed the position of the circles
                    const target = diagramInstance.nodes.find(node => node.id === `a${pluginUuid}`);
                    diagramInstance.select([target]);

                    this.onDiagramEvent({
                        payload: {
                            anchorUuid: pluginUuid,
                            pluginUuid,
                            anchorPosition,
                            pluginId
                        },
                        type: "SELECTED_ANCHORED_PLUGIN"
                    });
                }
            }
        },
        selectionChange(ev) {
            if (ev.state !== "Changed") {
                return;
            }
            let payload;
            const {
                newValue,
                newValue: [element]
            } = ev;
            diagramInstance.nodes.forEach(node => {
                node.style.strokeColor = "none";
            });
            if (newValue.length === 1) {
                element.style.strokeColor = "#3E71D2"; // highlight
                const {
                    id: PLUGIN_UUID,
                    data: { typeId: PLUGIN_ID }
                } = element || {};
                payload = {
                    payload: {
                        PLUGIN_ID,
                        PLUGIN_UUID: PLUGIN_UUID.substring(1) // the letter "a" is appended to the node id when created
                        // now is removed to make the id great again :)
                        // in syncfusion, annotations rendered as html get a htmlId that starts with node uuid
                        // the library then does a querySelector on the id... then errors because the id doesn't start with a letter...
                        // now you know...
                    },
                    type: "PLUGIN_SELECTED"
                };
            } else {
                payload = {
                    payload: {
                        PLUGIN_UUID: null,
                        PLUGIN_ID: null
                    },
                    type: "PLUGIN_SELECTED"
                };
            }
            this.onDiagramEvent(payload);
        },
        saveSettings() {
            this.settingsEnabled = false;
            const diagramId = this.showStatistics ? this.getSelectedProcessStatistics.id : this.getCurrentSelectedProcess.id;
            return $http(
                {
                    url: `/design/process/${diagramId}/diagram/settings`,
                    type: "PUT",
                    data: {
                        ...this.diagramSettings
                    }
                },
                true
            );
        },
        getSettings() {
            this.settingsEnabled = false;
            const diagramId = this.showStatistics ? this.getSelectedProcessStatistics.id : this.getCurrentSelectedProcess.id;
            return $http(
                {
                    url: `/design/process/${diagramId}/diagram/settings`,
                    type: "GET"
                },
                true
            ).then((data) => {
                const { showGrid = true, showBridges = true, showLabels = true } = data.data;
                if (showGrid !== this.diagramSettings.showGrid) {
                    this.applyGrid(showGrid, false);
                }
                if (showBridges !== this.diagramSettings.showBridges) {
                    this.applyBridges(showBridges, false);
                }
                if (showLabels !== this.diagramSettings.showLabels) {
                    this.applyAnnotations(showLabels, false);
                }
            });
        },
        applyGrid(value, save) {
            if (this.diagramSettings.showGrid !== value) {
                this.diagramSettings.showGrid = value;
                if (save) {
                    this.saveSettings().finally(() => {
                        setTimeout(() => {
                            this.settingsEnabled = true;
                        }, 500);
                    });
                }
            }
            if (value && diagramInstance.snapSettings.constraints !== 15) {
                diagramInstance.snapSettings.constraints = 15; // SnapConstraints.ShowLines | SnapConstraints.SnapToLines,
            } else if (!value && diagramInstance.snapSettings.constraints !== 12) {
                diagramInstance.snapSettings.constraints = 12; // SnapConstraints.SnapToLines,
            }
        },
        applyBridges(value, save) {
            if (this.diagramSettings.showBridges !== value) {
                this.diagramSettings.showBridges = value;
                if (save) {
                    this.saveSettings().finally(() => {
                        setTimeout(() => {
                            this.settingsEnabled = true;
                        }, 500);
                    });
                }
            }

            if (value) {
                diagramInstance.connectors.forEach(conn => {
                    conn.constraints = 256;
                });
            } else {
                diagramInstance.connectors.forEach(conn => {
                    conn.constraints = 16384;
                });
            }
        },
        applyAnnotations(value, save) {
            if (this.diagramSettings.showLabels !== value) {
                this.diagramSettings.showLabels = value;
                if (save) {
                    this.saveSettings().finally(() => {
                        setTimeout(() => {
                            this.settingsEnabled = true;
                        }, 500);
                    });
                }
                diagramInstance.connectors.forEach(conn => {
                    conn.annotations.forEach(ann => {
                        ann.visibility = value;
                    });
                });
                diagramInstance.nodes.forEach(node => {
                    node.annotations[0].visibility = value;
                });
                diagramInstance.dataBind();
            }
        },
        loadDiagram(data) {
            diagramInstance.reset();
            diagramInstance.loadDiagram(data);
            this.centerDiagram();
        },
        zoom(inn) {
            if (inn === "reset") {
                diagramInstance.reset();
                this.centerDiagram();
            } else if (inn) {
                diagramInstance.zoom(1.1);
            } else {
                diagramInstance.zoom(0.9);
            }
        },
        scrollChange(args) {
            this.zoomLevel = Math.round(args.newValue.CurrentZoom * 100);
        },
        centerDiagram() {
            setTimeout(() => {
                const coords = diagramInstance.diagramLayer.getBoundingClientRect();
                const area = new Rect(coords.x, coords.y, coords.width, coords.height);
                diagramInstance.bringToCenter(area);
            });
        },
        changeDiagramStatus(editable) {
            if (editable) {
                // eslint-disable-next-line no-bitwise
                diagramInstance.tool = ~DiagramTools.MultipleSelect;
                this.readonly = false;
            } else {
                diagramInstance.tool = DiagramTools.ZoomPan;
                this.readonly = true;
            }
        },
        loadPerspective(perspectiveId) {
            this.actLoadCasePerspectiveData(perspectiveId)
                .then(({ data }) => {
                    eventBus.$emit("perspectiveLoaded");
                    this.$store.commit("perspectiveBuilder/setPerspectiveId", perspectiveId);
                    let process = {};
                    const { processId: id, processName: name } = data.setup;

                    if (id && name) {
                        process = { id, name };
                        process.perspectiveId = perspectiveId;
                    }
                    this.currentSelectedPerspectiveId = perspectiveId;
                    this.setPerspectiveConfig({ ...data, process });
                    this.loading = false;
                    this.perspectiveNoProcessId = null;
                })
                .catch(() => {
                    this.currentSelectedPerspectiveId = null;
                    const data = { process: { id: "" }, perspectiveId };
                    this.setPerspectiveConfig(data);
                });
        },
        crumbOpen(perspectiveId) {
            const entity = (this.getPerspectivesList || []).find(({ id }) => id === perspectiveId);
            this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
            this.$store.commit("perspectiveBuilder/setSearchPerspectiveData", entity || {});
            this.$nextTick(() => {
                this.loadPerspective(perspectiveId);
            });
        },
        checkPermissionPerspective() {
            if (this.allowRedirectDenied) {
                if (this.pageType === "reports" && !this._inactive) {
                    this.allowRedirectDenied = false;
                    this.$router.push("/accessDenied");
                } else if (!this.perspectiveTakeAction) {
                    this.perspectiveTakeAction = true;
                    if (this.perspectiveList.length > 1) {
                        this.perspectiveNoProcessId = null;
                        if (this.selectedPluginUuid) {
                            this.$store.commit("diagrams/selectedPluginUuid", "");
                        }
                        this.$store.commit("reports/setSelectedProcessReports", { process: {}, pageType: this.pageType });
                        this.updatePerspective++;
                    } else {
                        this.allowRedirectDenied = false;
                        this.$router.push("/accessDenied");
                    }
                }
            }
        },
        returnToDefault(selectedTab, reset) {
            if (this.isSearchPerspective) {
                if (reset) {
                    this.updatePerspective = 0;
                    this.$root.$off("bc__searchPerspectives__open");
                    this.$store.commit("perspectiveBuilder/setSearchPerspectiveData", {});
                } else {
                    this.updatePerspective++;
                }

                this.currentSelectedPerspectiveId = null;
                this.perspectiveNoProcessId = null;
                this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
            } else if (selectedTab === "tasks") {
                this.allowRedirectDenied = true;
                this.removeEventListeners();
                this.$root.$emit("activeEnterEv");
                this.$store.commit("reports/setAllDataModelList", []);
                this.plvStatusMode = false;
                this.showStatistics = false;
                this.usersList = [];
                this.groupsList = [];
                this.isOpenAndCompleted = false;
                this.searchTerm = "";
                this.dataModelArray = [];
                this.nrFiltersApplied = 0;
                this.resetFilters = true;
                this.$store.commit("reports/setFiltredTasks", []);
                this.$store.commit("reports/setFilterObject", { taskFilterModel: {} });
                // this.$refs.diagram.selectPlugin();
                // this.$refs.diagram.resetZoom();
                this.$root.$off("backendWebsocketEvents-publishedApp");
                if (this.selectedPluginUuid) {
                    this.$store.commit("diagrams/selectedPluginUuid", "");
                }
                this.$store.commit("reports/setSelectedProcessReports", { process: {}, pageType: this.pageType });
                this.$nextTick(() => {
                    this.resetFilters = false;
                });
            } else {
                this.$store.commit("diagrams/selectedPluginUuid", "");
                this.$store.commit("reports/setSelectedProcessStatistics", {});
            }
        },
        goToSearchList() {
            this.$router.replace({ path: `/applications/${this.currentApp.id}/dataViews` });
        },
        getProcesses() {
            this.loading = true;
            this.getProcessesForReports(this.currentApp.id).then(rsp => {
                if (rsp.data) {
                    this.processList = [...rsp.data];
                    this.loading = false;
                    if (this.getCurrentSelectedProcess.id) {
                        const process = this.processList.find(el => el.id === this.getCurrentSelectedProcess.id) || {};
                        this.$store.commit("reports/setSelectedProcessReports", { process, pageType: this.pageType });
                    }
                    if (this.$route.params.processAnalyticsId) {
                        this.processList.forEach(process => {
                            if (process.id === this.$route.params.processAnalyticsId) {
                                this.selectProcess(process);
                            }
                        });
                    }
                    this.searchForProcess();
                }
            });
        },
        searchForProcess() {
            let processesStatisticsList = [];
            const search = this.searchProcess.trim();
            if (search && search.length >= 3) {
                const searchLowerCase = search.toLowerCase();
                for (let i = 0; i < this.processList.length; i++) {
                    if (this.processList[i].name.toLowerCase().includes(searchLowerCase)) {
                        processesStatisticsList.push(this.processList[i]);
                    }
                }
                if (!this.$route.params.processAnalyticsId) {
                    this.$router.replace({ query: { search } });
                }
            } else {
                processesStatisticsList = this.processList;
                if (!this.$route.params.processAnalyticsId) {
                    const { path, fullPath } = this.$route;
                    const checkMatchRoute = this.$router.match({ path, query: {} });

                    if (fullPath !== checkMatchRoute.fullPath) {
                        this.$router.replace({ query: {} });
                    }
                }
            }
            this.filteredProcessesList = processesStatisticsList;
        },
        processDiagramDetails(searchAction) {
            const payload = { ...this.filterObject, ...this.computedThresholds };
            this.actionGetAllTasks({ data: payload, activeTab: this.activeTab, pageType: this.pageType }).then(rsp => {
                this.allTasksReady = true;
                this.$store.commit("reports/setAllTasks", rsp);
                this.$store.commit("reports/setFiltredTasks", rsp);
                this.$store.commit("reports/setInitialDiagramData", rsp);
                this.isReady = false;
                this.resetFilters = false;
                rsp.forEach(element => {
                    this.setPluginTasks(element);
                });
                if (this.isSearchPerspective) {
                    const { filters: dataFilters } = this.perspectiveData;
                    const hasActivity = dataFilters.fields.find(elem => elem.value === "activity" && elem.visible);
                    if (searchAction) {
                        const { filters, table } = this.perspectiveData;
                        const [first, second] = filters.fields.filter(({ value, visible }) => (["activity", "taskStatus"].includes(value) && visible));
                        const checkIfActivity = () => (!second && first && first.value === "taskStatus") || (!first && second && second.value === "taskStatus")
                        || (!first && !second);
                        const checkActivityInvisible = () => {
                            const checkActivity = (v) => (v && v.value === "activity" && v.invisibleToUser);
                            return checkActivity(first) || checkActivity(second);
                        };
                        const checkAvailableTabs = () => {
                            const tabs = table.tabs.filter(({ visible }) => visible);
                            return tabs.length === 1;
                        };
                        if (checkIfActivity() || checkActivityInvisible() || checkAvailableTabs()) {
                            this.changeDiagramStatus();
                        } else {
                            this.changeDiagramStatus(true);
                        }
                    }
                    if (!hasActivity) {
                        this.activitiesDataPerspective = rsp;
                    }
                }
            });
            const payload2 = {
                interfaceName: "reports",
                processDefinitionId: this.getCurrentSelectedProcess.id,
                perspectiveCase: this.pageType === "searchPerspectives",
                perspectiveId: this.getPerspectiveId,
                appId: this.getCurrentApplicationId
            };
            if ((this.pageType !== "searchPerspectives" || this.perspectiveData.filters.canSaveFilters) && this.activeTab !== "statistics") {
                this.getAllFavoritesFilters(payload2).then(data => {
                    this.favoriteFilters = data;
                });
            }
        },
        setPerspectiveList(data) {
            this.perspectiveList = data;
        },
        setPerspectiveConfig(data) {
            this.perspectiveTakeAction = false;
            if (data.process.id) {
                this.updatePerspective = 0;
                if (this.getCurrentSelectedProcess.id) {
                    this.resetFilters = true;
                }
                if (this.perspectiveData.id && this.perspectiveData.id !== data.id) {
                    eventBus.$emit("resetPerspectiveCurrentPage");
                }
                this.perspectiveNoProcessId = null;
                this.perspectiveData = data;
                const { setup, table, filters } = this.perspectiveData;
                this.keepDiagramHidden = !setup.showDiagram;
                const [first, second] = filters.fields.filter(({ value, visible }) => ["activity", "taskStatus"].includes(value) && visible);
                const checkIfActivity = () => (!second && first && first.value === "taskStatus") || (!first && second && second.value === "taskStatus")
                        || (!first && !second);

                const checkActivityInvisible = () => {
                    const checkActivity = (v) => (v && v.value === "activity" && v.invisibleToUser);
                    return checkActivity(first) || checkActivity(second);
                };

                const checkAvailableTabs = () => {
                    const tabs = table.tabs.filter(({ visible }) => visible);
                    return tabs.length === 1;
                };
                let hasInvisibleStatus;
                const getActivity = v => {
                    let newData;
                    const { value, invisibleToUser, fieldValue } = v || {};
                    if (invisibleToUser) {
                        if (value === "activity") {
                            newData = [fieldValue[0].value];
                        } else if (value === "taskStatus") {
                            hasInvisibleStatus = fieldValue[0].value;
                        }
                    }

                    return newData;
                };
                const invisibleActivityField = getActivity(first) || getActivity(second);
                if (invisibleActivityField) {
                    this.getAllReportsActivities(this.perspectiveData.process.id).then(response => {
                        this.activitiesData = response;
                    });
                }
                if (checkIfActivity() || checkActivityInvisible() || checkAvailableTabs()) {
                    this.changeDiagramStatus();
                } else {
                    this.changeDiagramStatus(true);
                }
                const getStatus = v => (v === "expanded" ? "expand" : "collapse");
                if (setup.searchState === "collapsed") {
                    this.closeSearch();
                } else {
                    this.openSearchFilters();
                }

                this.propFullScreen = setup.tableState === "fullscreen";
                this.hasCustomInterface = setup.activeCustomInterface && !!setup.interfaceId;
                this.currentPerspective = this.perspectiveData.id;
                this.propExpandCollapse = this.propFullScreen ? "" : getStatus(setup.tableState);

                if (this.propFullScreen) {
                    this.setTasksFullscreen(true);
                } else {
                    this.tasksIsFullScreen = false;
                    this.setTasksStatus(this.propExpandCollapse);
                }
                let hasOneTab;
                let hideRedirectInstance;
                table.tabs.forEach(({ visible, value }) => {
                    if (value === "tab-tasks" && !visible) {
                        hasOneTab = true;
                    }
                });
                if (!hasOneTab) {
                    const noFieldSearch = filters.fields.find(({ value, visible }) => value === "search" && !visible);
                    if (noFieldSearch) {
                        hideRedirectInstance = true;
                    }
                }

                this.tableExtData = {
                    tabs: table.tabs,
                    allowSorting: table.columnSorting,
                    allowSettings: table.columnSettings,
                    allowExport: table.dataExport,
                    allowUseSettingsModel: table.allowSettingsDataModel,
                    tasksColumns: table.tasksColumns,
                    instancesColumns: table.casesColumns,
                    showFullScreenBtn: setup.showDiagram,
                    perspectiveActivity: invisibleActivityField,
                    perspectiveTasksStatus: hasInvisibleStatus,
                    hideRedirectInstance
                };
                this.selectProcess(data.process, true);
                this.$nextTick(() => {
                    if (this.$refs.tasksInstancesRef && this.propExpandCollapse !== "collapse") {
                        this.resizeTasksContainer();
                    }
                });
            } else {
                this.perspectiveNoProcessId = data ? data.perspectiveId : null;
                if (this.selectedPluginUuid) {
                    this.$store.commit("diagrams/selectedPluginUuid", "");
                }
                this.$store.commit("reports/setSelectedProcessReports", { process: {}, pageType: this.pageType });
            }
            this.loading = false;
        },
        selectProcess(process, searchAction, editFromList) {
            const checkIfProcess = this.pageType === "searchPerspectives"
                || this.activeTab === "statistics"
                || !this.getCurrentSelectedProcess.id || this.getCurrentSelectedProcess.id !== process.id;
            if (checkIfProcess) {
                if (this.activeTab === "tasks") {
                    if (this.pageType === "reports" && this.getCurrentSelectedProcess.id) {
                        this.resetFilters = true;
                    }
                    this.$nextTick(() => {
                        if (this.isSearchPerspective) {
                            this.resetFilters = false;
                        }
                        this.$store.commit("reports/setSelectedProcessReports", { process, pageType: this.pageType });
                        this.changeData(true, this.getCurrentSelectedProcess.id, false, searchAction);

                        if (!this.$route.query.filterId) {
                            const { query } = this.$route;
                            let newQuery = query;
                            if (editFromList) {
                                const { search, ...otherQuery } = query;
                                newQuery = otherQuery;
                            }

                            const { path, fullPath, params } = this.$route;
                            const checkMatchRoute = this.$router.match({ path, params: { processAnalyticsId: process.id }, query: newQuery });

                            const checkCustomParam = () => (this.isSearchPerspective
                                ? params.dataViewsId !== process.perspectiveId : params.processAnalyticsId !== process.id);

                            const getCustomParam = () => (this.isSearchPerspective
                                ? { dataViewsId: process.perspectiveId } : { processAnalyticsId: process.id });

                            if (fullPath !== checkMatchRoute.fullPath || checkCustomParam()) {
                                this.$router.replace({ params: getCustomParam(), query: newQuery });
                            }
                        }
                    });
                } else {
                    this.$store.commit("diagrams/selectedPluginUuid", "");
                    this.$store.commit("reports/setSelectedProcessStatistics", process);
                    this.changeData(false, this.getSelectedProcessStatistics.id);
                    this.$router.replace({ params: { processAnalyticsId: process.id } });
                }
            }
        },
        getActiveProcess(item) {
            let classToReturn = "";
            if (this.activeTab === "tasks" && this.getCurrentSelectedProcess.id === item.id) {
                classToReturn = "keep-selected";
            } else if (this.activeTab === "statistics" && this.getSelectedProcessStatistics.id === item.id) {
                classToReturn = "keep-selected";
            }
            return classToReturn;
        },
        setTasksStatus(action) {
            if (this.tasksIsFullScreen) {
                this.tasksIsFullScreen = false;
                this.contentTasksStatus = "";
            } else {
                this.contentTasksStatus = action;
                if (this.pageType === "searchPerspectives" && this.propExpandCollapse !== action) {
                    this.propExpandCollapse = action;
                }
            }
        },
        setTasksFullscreen(action) {
            this.tasksIsFullScreen = action;
            if (this.pageType === "searchPerspectives" && this.propFullScreen !== action) {
                this.propFullScreen = action;
            }
            this.resizeTasksContainer();
        },
        resizeTasksContainer() {
            if (this.tasksIsFullScreen) {
                const searchHeight = this.$refs.searchFiltersRef && this.$refs.searchFiltersRef.clientHeight ? this.$refs.searchFiltersRef.clientHeight : null;
                this.contentTasksStatus = "";
                this.$refs.tasksInstancesRef.setAttribute("style", `height:calc(100% - 16px - ${searchHeight || 60}px)`);
            } else {
                this.contentTasksStatus = "expand";
                this.$refs.tasksInstancesRef.setAttribute("style", "height:40%");
            }
        },
        closeSearch() {
            this.collapseSearchFilters = true;
            this.showSearchContent = false;
        },
        openSearchFilters() {
            this.collapseSearchFilters = false;
        },
        loadFavoriteFilter(id) {
            const payload = {
                id,
                processDefinitionId: this.getCurrentSelectedProcess.id,
                appId: this.getCurrentApplicationId,
                perspectiveId: this.getPerspectiveId,
                perspectiveCase: this.pageType === "searchPerspectives"
            };
            this.getFilter(payload)
                .then(data => {
                    const timeoutToLoad = this.collapseSearchFilters ? 300 : 0;
                    this.collapseSearchFilters = false;
                    setTimeout(() => {
                        this.filterDetails = data;
                        this.getDataModelList();
                    }, timeoutToLoad);
                })
                .catch(() => {
                    this.$toast.showNotify({
                        type: "error",
                        code: "filter-loadFail",
                        message: this.$t("searchPerspectives.loadFilterError")
                    });
                });
        },
        openSearchContainer(open) {
            if (open) {
                this.collapseSearchFilters = false;
            }
        },
        getSearchPayload(payload, resetDiagramOnly) {
            if (!this._inactive) {
                const taskPayload = JSON.parse(JSON.stringify(payload));
                if (!resetDiagramOnly) {
                    this.$root.$emit("getItemsReports", payload);
                }
                delete taskPayload.page;
                delete taskPayload.size;
                const diagramElems = this.diagramData.content;
                const payloadProps = taskPayload.taskAndInstanceFilterModel;
                if (diagramElems && payloadProps.activityIds && payloadProps.taskStatus && payloadProps.activityIds.length && payloadProps.taskStatus.length) {
                    const [activityId] = payloadProps.activityIds;
                    const selectedElem = diagramElems.find(elem => elem.uuid === activityId && elem.id === "GENERAL_END_PLUGIN");
                    if (selectedElem) {
                        taskPayload.taskAndInstanceFilterModel.taskStatus = [];
                    }
                }
                const { id: processId, perspectiveId } = this.showStatistics ? this.getSelectedProcessStatistics : this.getCurrentSelectedProcess;
                if (processId) {
                    taskPayload.taskAndInstanceFilterModel.processDefinitionId = processId;
                }
                const getAccessToActivity = this.isSearchPerspective ? perspectiveId && !this.resetFilters : !this.resetFilters;

                if (
                    this.pageType === "searchPerspectives"
                    && !taskPayload.taskAndInstanceFilterModel.taskStatus.length
                    && this.tableExtData
                    && this.tableExtData.perspectiveTasksStatus
                ) {
                    taskPayload.taskAndInstanceFilterModel.taskStatus = this.tableExtData.perspectiveTasksStatus;
                }
                if (getAccessToActivity) {
                    this.getActivityReportsTasks({ pageType: this.pageType, taskPayload })
                        .then(response => {
                            response.forEach(element => {
                                this.setPluginTasks(element);
                            });
                            const isCompletedTasks = payload.taskAndInstanceFilterModel.instanceStatuses.includes("COMPLETED");
                            if (isCompletedTasks) {
                                this.updateAnchorPlugin(true, response);
                            } else {
                                this.updateAnchorPlugin(null, response);
                            }
                        })
                        .catch(({ response = {} }) => {
                            const { data: { status, error } = {} } = response;
                            if (status === 401) {
                                this.checkPermissionPerspective();
                            } else if (status === 409) {
                                this.$toast.showNotify({
                                    type: "error",
                                    code: "filter-loadFail",
                                    message: this.$t("searchPerspectives.loadFilterError")
                                });
                            } else if (status === 400) {
                                this.$toast.showNotify({
                                    type: "error",
                                    code: "filter-loadFail",
                                    message: error
                                });
                            }
                        });
                }
            }
        },
        getDataModelList() {
            if (this.contentTasksStatus !== "collapse") {
                setTimeout(() => {
                    this.resizeTasksContainer();
                }, 0);
            }
        },
        collapseSideBar(action) {
            const timeout = action ? 300 : 0;
            setTimeout(() => {
                if (timeout) {
                    this.getDataModelList();
                }
            }, timeout);
            this.expandDiagramContent = action;
        },
        expandSideBar() {
            this.getDataModelList();
            if (this.isSearchPerspective) {
                const { id } = this.perspectiveData || {};
                this.selectedPerspective = { selectedId: id || "", getData: true };
            }
        },
        tasksStartTransition() {
            if (!this.tasksIsFullScreen && this.hideDiagram) {
                this.hideDiagram = false;
            }
            this.setZoomBottomHeight = this.contentTasksStatus === "expand" ? "40%" : 50;
        },
        tasksEndTransition() {
            if (this.tasksIsFullScreen) {
                this.hideDiagram = true;
            }
        },
        searchStartTransition() {
            if (!this.collapseSearchFilters) {
                this.showSearchFilters = true;
            }
        },
        searchEndTransition(event) {
            if (event && event.propertyName === "left") {
                this.showSearchFilters = false;
            }
            if (!this.collapseSearchFilters) {
                this.showSearchFilters = true;
                this.showSearchContent = true;
            }
            if (this.contentTasksStatus !== "collapse") {
                this.resizeTasksContainer();
            }
        },
        onWindowResize() {
            if (this.setZoomBottomHeight && this.$refs) {
                setTimeout(() => {
                    this.setZoomBottomHeight = this.$refs.tasksInstancesRef.clientHeight;
                }, 0);
            }
        },
        addEventListeners() {
            if (this.$refs.searchFiltersRef) {
                this.$refs.searchFiltersRef.addEventListener("transitionstart", this.searchStartTransition);
                this.$refs.searchFiltersRef.addEventListener("transitionend", this.searchEndTransition);
            }
            if (this.$refs.tasksInstancesRef) {
                this.$refs.tasksInstancesRef.addEventListener("transitionstart", this.tasksStartTransition);
                this.$refs.tasksInstancesRef.addEventListener("transitionend", this.tasksEndTransition);
                this.setZoomBottomHeight = this.$refs.tasksInstancesRef.clientHeight;
            }
            window.addEventListener("resize", this.onWindowResize);
        },
        removeEventListeners() {
            if (this.$refs.searchFiltersRef) {
                this.$refs.searchFiltersRef.removeEventListener("transitionstart", this.searchStartTransition);
                this.$refs.searchFiltersRef.removeEventListener("transitionend", this.searchEndTransition);
            }
            if (this.$refs.tasksInstancesRef) {
                this.$refs.tasksInstancesRef.removeEventListener("transitionstart", this.tasksStartTransition);
                this.$refs.tasksInstancesRef.removeEventListener("transitionend", this.tasksEndTransition);
            }
            window.removeEventListener("resize", this.onWindowResize);
        },
        checkGeneralStartRecurrence() {
            if (this.diagramConfigData && this.diagramConfigData.content) {
                this.diagramConfigData.content.forEach(element => {
                    if (element.pluginType === "GENERAL_START_PLUGIN") {
                        if (element.recurrence && element.recurrence.endDate) {
                            const newDate = new Date();
                            const recurrenceDate = new Date(element.recurrence.endDate);
                            const diff = date.getDateDiff(recurrenceDate, newDate, "days");
                            if (diff < 0) {
                                for (let i = 0; i < this.diagramData.content.length; i++) {
                                    const plugin = this.diagramData.content[i];
                                    if (plugin.uuid === element.uuid && plugin.label.additionalOptions) {
                                        plugin.label.additionalOptions = { ...plugin.label.additionalOptions, recurrenceExpired: true };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                });
            }
        },
        setViewModifications() {
            this.getFiltredTasks.forEach(element => {
                this.setPluginTasks(element);
            });
            if (this.isCompleted) {
                this.isCompleted = false;
                this.updateAnchorPlugin(true);
            } else {
                this.updateAnchorPlugin();
            }
        },
        eventEmitted(event) {
            this.$store.commit("diagrams/selectedPluginCode", event.id);
        },
        selectPlugin(plugin) {
            const target = diagramInstance.nodes.find(({ id }) => id === `a${plugin.uuid}`);
            if (target) {
                diagramInstance.select([target]);
            }
            this.$store.commit("diagrams/selectedPluginUuid", plugin.uuid);
            this.$store.commit("diagrams/selectedPluginCode", plugin.id);
        },
        modalClosed() {
            this.addFilterModal = false;
        },
        routeTo(to) {
            this.refreshDataWhenTabChanges = false;
            if (to === "statistics") {
                this.removeEventListeners();
                this.$store.commit("diagrams/selectedPluginUuid", "");
                this.turnAroundValue = "ONE_WEEK";
                this.activeTab = "statistics";
                this.returnToDefault("statistics");
                this.showStatistics = true;
                if (this.getSelectedProcessStatistics.id) {
                    this.changeData(false, this.getSelectedProcessStatistics.id);
                }
            } else {
                this.activeTab = "tasks";
                this.returnToDefault("tasks");
                this.showStatistics = false;
                if (this.getCurrentSelectedProcess.id) {
                    this.changeData(true, this.getCurrentSelectedProcess.id, "updateAnchor");
                    this.refreshDataWhenTabChanges = true;
                }
                this.$nextTick(() => {
                    this.addEventListeners();
                });
            }
            this.$root.$emit("activeEnterEv", !this.showStatistics);
        },
        turnAroundValueChanged(newValue) {
            this.turnAroundValue = newValue;
        },
        openSavedFilters() {
            this.showSavedFiltersModal = true;
        },
        getActivitiesData(value) {
            this.activitiesData = JSON.parse(JSON.stringify(value));
        },
        closeFiltersModal() {
            const payload = {
                interfaceName: "reports",
                processDefinitionId: this.getCurrentSelectedProcess.id,
                perspectiveCase: this.pageType === "searchPerspectives",
                perspectiveId: this.getPerspectiveId,
                appId: this.getCurrentApplicationId
            };
            if (this.pageType !== "searchPerspectives" || this.perspectiveData.filters.canSaveFilters) {
                this.getAllFavoritesFilters(payload).then(data => {
                    this.favoriteFilters = data;
                });
            }
            this.showSavedFiltersModal = false;
        },
        updateFilterList(filtersList) {
            this.filtersList = filtersList;
        },
        getFilterDetails(data) {
            this.filterDetails = data;
            this.getDataModelList();
        },
        updateAnchorPlugin(isTaskCompleted, data) {
            const dataFilters = data || this.getFiltredTasks;
            diagramInstance.nodes.forEach(node => {
                if (node.annotations[1]) {
                    node.annotations[1].template = "";
                    node.annotations[1].width = 0;
                }
            });
            dataFilters.forEach(elem => {
                const payload = {
                    nodeUuid: `${elem.activityId}`,
                    plugins: []
                };
                if (elem.total) {
                    payload.plugins.push(["total", elem.total]);
                }
                if (elem.onTrack) {
                    payload.plugins.push(["onTrack", elem.onTrack]);
                }
                if (elem.attention) {
                    payload.plugins.push(["attention", elem.attention]);
                }
                if (elem.atRisk) {
                    payload.plugins.push(["atRisk", elem.atRisk]);
                }
                if (elem.overdue) {
                    payload.plugins.push(["overdue", elem.overdue]);
                }
                if (payload.plugins.length) {
                    setAnchoredOnDiagram(diagramInstance, payload);
                }
            });
        },
        changeData(excludeThresholds, processId, updateAnchor, searchAction) {
            this.getSettings().finally(() => {
                this.$store.dispatch("diagrams/getDataJson", { procId: processId, fromReports: true }).then(() => {
                    this.checkGeneralStartRecurrence();
                    if (this.diagramData.connectors.length > 299) {
                        this.applyBridges(false, true);
                    }
                    this.loadDiagram(convertOldDiagram(this.diagramData, this.diagramSettings));
                    this.refreshDiagram = false;
                    if (!excludeThresholds) {
                        this.getAllTasksDiagrams(this.computedThresholds);
                    }
                    this.$nextTick(() => {
                        this.processDiagramDetails(searchAction);
                        if (searchAction) {
                            this.$refs.searchContainerRef.searchItems();
                        }
                        if (updateAnchor) {
                            this.updateAnchorPlugin(true);
                        }
                    });
                    if (this.pageType === "reports") {
                        this.$store.commit("diagrams/setCopyOfInitialContentDiagram", JSON.stringify(this.diagramConfigData.content));
                    }
                    this.settingsEnabled = true;
                    this.diagramLoaded = true;
                });
            });
        },

        setPluginTasks(data) {
            const enabledPlugins = ["TASK_PLUGIN", "APPROVAL_PLUGIN", "EXTERNAL_PLUGIN", "BLOCKCHAIN_EVENT_PLUGIN"];
            const totalOnlyPlugins = ["GENERAL_END_PLUGIN", "EXPOSE_API_PLUGIN"];
            const diagramElements = this.diagramData.content;
            let showAnchored = true;
            if (this.isSearchPerspective) {
                const { fields } = this.perspectiveData.filters;
                const activityEdit = fields.filter(({ value, visible }) => ["activity", "taskStatus"].includes(value) && visible);
                if (activityEdit.length !== 1) {
                    const hasTasksInvisible = activityEdit.find(e => e.value === "taskStatus" && e.invisibleToUser);
                    showAnchored = hasTasksInvisible ? !hasTasksInvisible : true;
                }
            }

            // add hexagons for user tasks
            for (let i = 0; i < diagramElements.length; i++) {
                if (diagramElements[i].uuid === data.activityId) {
                    const payload = {
                        nodeUuid: diagramElements[i].uuid,
                        plugins: []
                    };
                    if (data.total) {
                        payload.plugins.push(["total", data.total]);
                    }
                    if (enabledPlugins.includes(diagramElements[i].id)) {
                        if (diagramElements[i].id !== "BLOCKCHAIN_EVENT_PLUGIN" && showAnchored) {
                            if (data.onTrack) {
                                payload.plugins.push(["onTrack", data.onTrack]);
                            }
                            if (data.attention) {
                                payload.plugins.push(["attention", data.attention]);
                            }
                            if (data.atRisk) {
                                payload.plugins.push(["atRisk", data.atRisk]);
                            }
                            if (data.overdue) {
                                payload.plugins.push(["overdue", data.overdue]);
                            }
                        }
                        setAnchoredOnDiagram(diagramInstance, payload);
                    } else if (totalOnlyPlugins.includes(diagramElements[i].id)) {
                        setAnchoredOnDiagram(diagramInstance, payload);
                    }
                    break;
                }
            }
        },
        diagramEvent(data) {
            if (data.type === "PLUGIN_SELECTED") {
                this.selectedAchoredPlugin = {};
                this.$store.commit("diagrams/selectedPluginCode", data.payload.PLUGIN_ID);
                this.$store.commit("diagrams/selectedPluginUuid", data.payload.PLUGIN_UUID);
            } else if (data.type === "SELECTED_ANCHORED_PLUGIN") {
                this.selectedAchoredPlugin = data.payload;
                this.$store.commit("diagrams/selectedPluginUuid", data.payload.anchorUuid);
                this.anchorPoz = data.payload.anchorPosition;
            }
        },

        getAllTasksDiagrams(data) {
            this.actionGetAllTasks({ data, activeTab: this.activeTab, pageType: this.pageType }).then(rsp => {
                this.$store.commit("reports/setAllTasks", rsp);
                rsp.forEach(element => {
                    this.setPluginTasks(element);
                });
            });
        },
        getStageDetails() {
            let filterType = "";
            const localFilter = JSON.parse(JSON.stringify(this.filterObject.taskFilterModel));
            if (this.anchorPoz) {
                if (this.anchorPoz === "TOP_LEFT") {
                    filterType = "ON_TRACK";
                } else if (this.anchorPoz === "TOP_RIGHT") {
                    filterType = "ATTENTION";
                } else if (this.anchorPoz === "BOTTOM_LEFT") {
                    filterType = "AT_RISK";
                } else if (this.anchorPoz === "BOTTOM_RIGHT") {
                    filterType = "OVERDUE";
                }
                if (filterType) {
                    localFilter.taskStatus = [filterType];
                }
            }
            const activityPayload = {
                lvThresholdFilterModel: this.computedThresholds.lvThresholdFilterModel,
                page: 0,
                size: 5,
                sortDirection: "ASC",
                sortField: this.currentPluginSelectedData.pluginType === "GENERAL_END_PLUGIN" ? "startDate" : "creationDate",
                taskFilterModel: localFilter,
                searchTerm: this.filterObject.searchTerm ? this.filterObject.searchTerm : ""
            };
            if (typeof this.filterObject.activeTasks === "boolean") {
                activityPayload.activeTasks = this.filterObject.activeTasks;
            }
            this.$store.commit("reports/setSearchInSearchFilter", activityPayload);
            this.$store.commit("reports/setCurrentPluginData", this.currentPluginSelectedData);
            this.anchorPoz = null;
        }
    }
};
